import React from 'react';
import {
  DialogTitle,
  Button,
  DialogActions,
  DialogContent,
  TextField,
  Grid,
  LinearProgress
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import Dialog from '../Dialog';
import FancyDropDown from '../FancyDropDown';
import { inputFieldNames } from '../../constants';

const useStyles = makeStyles((theme) => ({
  dialog: {},
  dialogTitle: {
    background: '#f0f0f0'
  },
  dialogContent: {
    width: 580,
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(3)
  },
  actionButton: {
    width: 180,
    float: 'right',
    margin: theme.spacing(2)
  },
  footer: {
    background: '#f0f0f0'
  },
  multilineTextBox: {
    marginTop: 20
  }
}));

const CreateEditBranchFormUI = (props) => {
  const classes = useStyles();
  const {
    openDialog,
    openCreateBranchDialog,
    onHandleInputChange,
    branch,
    title,
    isSaving,
    companies,
    handleSubmit
  } = props;

  const onDialogClose = () => {
    openCreateBranchDialog(false);
  };

  const handleInputChange = (e, inputfieldName) => {
    onHandleInputChange(e.target.value, inputfieldName);
  };

  return (
    <React.Fragment>
      <Dialog
        open={openDialog}
        onClose={onDialogClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className={classes.dialog}
      >
        {isSaving ? <LinearProgress /> : ''}
        <DialogTitle id="alert-dialog-title" className={classes.dialogTitle}>
          {title}
        </DialogTitle>
        <form onSubmit={handleSubmit}>
          <DialogContent className={classes.dialogContent}>
            <Grid container className={classes.formContainer}>
              <Grid item xs={6}>
                <TextField
                  required
                  id="BranchName"
                  label="Name"
                  onChange={(e) => handleInputChange(e, inputFieldNames.NAME)}
                  value={branch.name}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  required
                  id="BranchContactPerson"
                  label="Contact person"
                  onChange={(e) =>
                    handleInputChange(e, inputFieldNames.CONTACT_PERSON)
                  }
                  value={branch.contactPerson}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  id="BranchEmail"
                  label="Email"
                  onChange={(e) => handleInputChange(e, inputFieldNames.EMAIL)}
                  value={branch.email}
                />
              </Grid>
              <Grid item xs={6}>
                <FancyDropDown
                  htmlId="companyDropDown"
                  label="Company"
                  margin="normal"
                  value={branch.companyId}
                  handleChange={(e) =>
                    handleInputChange(e, inputFieldNames.COMPANY)
                  }
                  items={companies}
                  dropDownWidth="100%"
                  className={classes.dropDown}
                  valueField="id"
                  displayField="name"
                  required={true}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  id="BranchPhone"
                  label="Phone"
                  onChange={(e) => handleInputChange(e, inputFieldNames.PHONE)}
                  value={branch.phone}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  id="BranchFax"
                  label="Fax"
                  onChange={(e) => handleInputChange(e, inputFieldNames.FAX)}
                  value={branch.fax}
                />
              </Grid>
              <Grid item xs={12} className={classes.multilineTextBox}>
                <TextField
                  id="addressId"
                  label="Address"
                  multiline
                  rows={3}
                  fullWidth
                  variant="outlined"
                  onChange={(e) =>
                    handleInputChange(e, inputFieldNames.ADDRESS)
                  }
                  value={branch.address}
                />
              </Grid>
              <Grid item xs={12} className={classes.multilineTextBox}>
                <TextField
                  id="noteId"
                  label="Notes"
                  multiline
                  rows={3}
                  fullWidth
                  variant="outlined"
                  onChange={(e) => handleInputChange(e, inputFieldNames.NOTES)}
                  value={branch.notes}
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions className={classes.footer}>
            <Button
              onClick={onDialogClose}
              color="primary"
              variant="outlined"
              className={classes.actionButton}
              id="cancelButton"
            >
              Cancel
            </Button>
            <Button
              type="submit"
              color="primary"
              variant="contained"
              className={classes.actionButton}
              id="addChildButton"
              // disabled={!enableAddButton}
            >
              Add
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </React.Fragment>
  );
};

export default CreateEditBranchFormUI;
